import { Case } from "@/types/workflow";
import { CreateCaseDialog } from "./CreateCaseDialog";
import { EditCaseDialog } from "./EditCaseDialog";
import { DeleteCaseDialog } from "./DeleteCaseDialog";

interface CaseDialogsProps {
  selectedCase: Case | null;
  createDialogOpen: boolean;
  editDialogOpen: boolean;
  deleteDialogOpen: boolean;
  onCreateDialogChange: (open: boolean) => void;
  onEditDialogChange: (open: boolean) => void;
  onDeleteDialogChange: (open: boolean) => void;
  onEditSubmit: (values: { title: string; description: string }) => Promise<void>;
  onCreateSuccess: () => void;
  onDeleteConfirm: () => void;
}

export function CaseDialogs({
  createDialogOpen,
  editDialogOpen,
  deleteDialogOpen,
  selectedCase,
  onCreateDialogChange,
  onEditDialogChange,
  onDeleteDialogChange,
  onEditSubmit,
  onCreateSuccess,
  onDeleteConfirm,
}: CaseDialogsProps) {
  return (
    <>
      <CreateCaseDialog
        open={createDialogOpen}
        onOpenChange={onCreateDialogChange}
        onSuccess={onCreateSuccess}
      />

      {selectedCase && (
        <EditCaseDialog
          open={editDialogOpen}
          onOpenChange={onEditDialogChange}
          onSubmit={onEditSubmit}
          defaultValues={{
            title: selectedCase.title,
            description: selectedCase.description,
          }}
        />
      )}

      <DeleteCaseDialog
        open={deleteDialogOpen}
        onOpenChange={onDeleteDialogChange}
        onConfirmDelete={onDeleteConfirm}
      />
    </>
  );
}